import Layout from '../../components/Layout/Layout';
import Text from '../../components/Text';
import {Colors} from '../../configs';
import {useTheme} from '../../configs/Theme';
import React, {memo, useCallback} from 'react';
import {View, StyleSheet, TouchableOpacity, ViewProps} from 'react-native';
import Theme from '../../style/Theme';

interface Props {
  tabs?: string[];
  style?: ViewProps;
  activeTintColor?: string;
  inactiveTintColor?: string;
  activeBackgroundColor?: string;
  inactiveBackgroundColor?: string;
  tabStyle?: ViewProps;
  onChangeTab?: (index: number) => void;
}

export default memo(
  ({
    tabs,
    onChangeTab,
    style,
    tabStyle,
    activeTintColor = Colors.White,
    inactiveTintColor = Colors.GrayBlue,
    activeBackgroundColor = Colors.TealBlue,
    inactiveBackgroundColor,
  }: Props) => {
    const [tabActive, setTabActive] = React.useState<number>(0);
    const {theme} = useTheme();
    const _onChangeTab = useCallback(
      (number: number) => {
        setTabActive(number);
        onChangeTab && onChangeTab(number);
      },
      [onChangeTab],
    );

    return (
      <Layout
        style={[styles.container, style, {borderColor: theme.innearColor}]}>
        {tabs.map((item, index) => {
          const backgroundColor = {
            backgroundColor:
              tabActive === index
                ? activeBackgroundColor
                : theme.backgroundItem,
          };

          const tintColor =
            tabActive === index ? activeTintColor : inactiveTintColor;

          return (
            <TouchableOpacity
              onPress={() => _onChangeTab(index)}
              key={index}
              style={[styles.tabStyle, tabStyle, backgroundColor]}>
              <Text color={tintColor} size={13} lineHeight={16} semibold>
                {item}
              </Text>
            </TouchableOpacity>
          );
        })}
      </Layout>
    );
  },
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    ...Theme.flexDirection,
    justifyContent: 'space-around',
    borderRadius: 8,
    borderWidth: 1,
  },
  tabStyle: {
    height: 40,
    flex: 1,
    marginRight: 1,
    borderRadius: 8,
    ...Theme.center,
  },
});
